import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row w-full" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "card w-full mtop-10 pad-l" }
const _hoisted_4 = { class: "row w-full" }
const _hoisted_5 = ["src"]

import {useI18n} from "vue-i18n";
import { ref, onMounted, watch } from "vue";
import { InstituteLightResponse } from "@/apiGenerate/medserver/models/InstituteLightResponse";
import { AdminApi, CreateUpdateCommonFinancialGroupRequest, FinancialGroupLightResponse } from "@/apiGenerate/medserver";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { ApiError, SctLanguageItem } from "@/models/share.model";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import { useToast } from "primevue";
import { FilterMatchMode } from '@primevue/core/api';
import SharedService from "@/services/SharedService";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Tag from 'primevue/tag';
import EsManagePersonFinancialGroup from '@/components/modals/admin/esManagePersonFinancialGroup.vue';
import EsAddCommonFinancialGroupForm from '@/components/form/admin/esAddCommonFinancialGroupForm.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'esAdminFinancialGroup',
  props: {
  instituteList: {
    type: Array<InstituteLightResponse>,
    default: []
  }
},
  setup(__props) {



const { t } = useI18n();
const toast = useToast();

const adminApi = new AdminApi(medServerApiConfig);
const commonFinancialGroups = ref<FinancialGroupLightResponse[]>([]);
const selectedFinancialGroup = ref<FinancialGroupLightResponse>(undefined);
const financialGroupToUpdate = ref<FinancialGroupLightResponse>(undefined);
const loading = ref<boolean>(true);
const openManagePersonFinancialGroupModal = ref<boolean>(false);
const openModalAddOrUpdateForm = ref<boolean>(false);
const headerAddOrUpdateForm = ref<string>(t('admin.financialGroup.form.add.header'));

const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
});
const dataTableColumns = [
    { field: 'title', header: t('admin.financialGroup.table.title') },
    { field: 'code', header: t('admin.financialGroup.table.code') },
    { field: 'active', header: t('admin.financialGroup.table.active') },
    { field: 'misaNumber', header: t('admin.financialGroup.table.misaNumber') },
    { field: 'personalInfo', header: t('admin.financialGroup.table.personalInfo') },
    { field: 'medicalPerson', header: t('admin.financialGroup.table.medicalPerson') }
];

const getAllCommonFinancialGroup = async () => {
  loading.value = true;
  adminApi.getAllCommonFinancialGroup().then((response: FinancialGroupLightResponse[]) => {
      commonFinancialGroups.value = response.sort((a, b) =>
          a.title.localeCompare(b.title, SctLanguageItem.FrFr, { sensitivity: 'base' })
      );
      loading.value = false;
  }).catch(() => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: t('error.DEFAULT')
      });
  });
}

const openAddForm = () => {
  openModalAddOrUpdateForm.value = true;
  headerAddOrUpdateForm.value = t('admin.financialGroup.form.add.header');
}

const closeAddOrUpdateFormModal = async (createUpdateCommonFinancialGroupRequest: CreateUpdateCommonFinancialGroupRequest) => {
  if (createUpdateCommonFinancialGroupRequest) {
    if (financialGroupToUpdate.value) {
      await updateCommonFinancialGroup(financialGroupToUpdate.value.id, createUpdateCommonFinancialGroupRequest);
    } else {
      await addCommonFinancialGroup(createUpdateCommonFinancialGroupRequest);
    }
  } else {
    openModalAddOrUpdateForm.value = false;
  }
  financialGroupToUpdate.value = undefined;
}

const addCommonFinancialGroup = async (createUpdateCommonFinancialGroupRequest: CreateUpdateCommonFinancialGroupRequest) => {
  await adminApi.addCommonFinancialGroup({createUpdateCommonFinancialGroupRequest: createUpdateCommonFinancialGroupRequest}).then(async () => {
      toastSuccess(toast, {
        summary: t('common.toast.success.add'),
        detail:  t('admin.financialGroup.form.add.message.success')
      });
      await getAllCommonFinancialGroup();
      openModalAddOrUpdateForm.value = false;
  }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });

      // Throw error to set at false the var __alreadyClicked in v-one-click directive
      throw error;      
  });
}

const updateCommonFinancialGroup = async (financialGroupId: number, createUpdateCommonFinancialGroupRequest: CreateUpdateCommonFinancialGroupRequest) => {
  await adminApi.updateCommonFinancialGroup({financialGroupId: financialGroupId, createUpdateCommonFinancialGroupRequest: createUpdateCommonFinancialGroupRequest}).then(async () => {
    toastSuccess(toast, {
      summary: t('common.toast.success.update'),
      detail:  t('admin.financialGroup.form.update.message.success')
    });
    await getAllCommonFinancialGroup();
    openModalAddOrUpdateForm.value = false;
    financialGroupToUpdate.value = undefined;
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });

    // Throw error to set at false the var __alreadyClicked in v-one-click directive
    throw error;
  });
}

const openManagePersonModal = (financialGroup: FinancialGroupLightResponse) => {
  selectedFinancialGroup.value = financialGroup;
  openManagePersonFinancialGroupModal.value = true;
}

const closeManagePersonModal = () => {
  selectedFinancialGroup.value = undefined;
  openManagePersonFinancialGroupModal.value = false;
}

const clearFilter = () => {
  filters.value = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
  };
};

watch(
  () => financialGroupToUpdate.value,
  async () => {
    if (financialGroupToUpdate.value && !openModalAddOrUpdateForm.value) {
      headerAddOrUpdateForm.value = t('admin.financialGroup.form.update.header');
      openModalAddOrUpdateForm.value = true;
    } else {
      openModalAddOrUpdateForm.value = false;
    }    
  }
);

onMounted(async () => {
    await getAllCommonFinancialGroup();
});


return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('admin.financialGroup.datatableTitle')), 1),
      _createVNode(_component_es_button, {
        label: _unref(t)('action.add'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openAddForm())),
        "is-primary": true
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        filters: filters.value,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((filters).value = $event)),
        selectionMode: "single",
        selection: financialGroupToUpdate.value,
        "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => ((financialGroupToUpdate).value = $event)),
        dataKey: "id",
        globalFilterFields: ['title', 'code', 'misaNumber', 'personalInfo'],
        loading: loading.value,
        value: commonFinancialGroups.value,
        stripedRows: "",
        paginator: "",
        rows: 10,
        rowsPerPageOptions: [5, 10, 20, 50],
        class: "w-full"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IconField), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputIcon), null, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(SharedService).getIcon('magnifyingglass', false, 'shareIcons'),
                      class: "img-grey"
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(InputText), {
                  modelValue: filters.value['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
                  placeholder: _unref(t)('admin.financialGroup.search')
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(_unref(InputIcon), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_es_button_icon, {
                      icon: "xmark",
                      folder: "shareIcons",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilter())),
                      styles: "img-grey"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('admin.financialGroup.table.empty')), 1)
        ]),
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('common.loading')), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dataTableColumns, (col) => {
            return _createElementVNode("div", {
              key: col.field
            }, [
              (col.field !== 'active' && col.field !== 'medicalPerson')
                ? (_openBlock(), _createBlock(_unref(Column), {
                    key: col.field,
                    field: col.field,
                    header: col.header,
                    sortable: ""
                  }, null, 8, ["field", "header"]))
                : _createCommentVNode("", true)
            ])
          }), 64)),
          _createVNode(_unref(Column), {
            field: 'active',
            header:  _unref(t)('admin.financialGroup.table.active')
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(Tag), {
                severity: slotProps.data.active ? 'success' : 'warn',
                value: slotProps.data.active ? _unref(t)('common.status.active') : _unref(t)('common.status.unactive')
              }, null, 8, ["severity", "value"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: 'medicalPerson',
            header:  _unref(t)('admin.financialGroup.table.medicalPerson')
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_es_button_icon, {
                icon: "person_fill",
                folder: "shareIcons",
                class: "pad-l",
                styles: "img-primary",
                onClick: ($event: any) => (openManagePersonModal(slotProps.data))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["filters", "selection", "loading", "value"])
    ]),
    _createVNode(EsManagePersonFinancialGroup, {
      isOpen: openManagePersonFinancialGroupModal.value,
      "current-financial-group": selectedFinancialGroup.value,
      onModalClose: _cache[5] || (_cache[5] = ($event: any) => (closeManagePersonModal()))
    }, null, 8, ["isOpen", "current-financial-group"]),
    _createVNode(EsAddCommonFinancialGroupForm, {
      isOpen: openModalAddOrUpdateForm.value,
      header: headerAddOrUpdateForm.value,
      "current-financial-group": financialGroupToUpdate.value,
      "confirm-method": closeAddOrUpdateFormModal,
      onModalClose: _cache[6] || (_cache[6] = ($event: any) => (openModalAddOrUpdateForm.value = false))
    }, null, 8, ["isOpen", "header", "current-financial-group"])
  ], 64))
}
}

})